import * as yup from "yup";

export const flowLogoUrl = "/flow/images/flow-base/logos/flow.jpg";

export const formDefaultValues = {
    username: "",
    password: "",
};

export const formValidationSchema = yup.object({
    username: yup.string().required(),
    password: yup.string().required(),
});

export const ERROR_TYPE_INVALID_CREDENTIALS = "INVALID_CREDENTIALS";

// FLOW5-4364: the backend now returns this single generic type for every login
// failure (unknown user, wrong password, locked, disabled) so the response
// cannot be used to enumerate usernames. INVALID_CREDENTIALS is kept for
// backward compatibility during rollout.
export const ERROR_TYPE_LOGIN_FAILED = "LOGIN_FAILED";
